// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import ckEditor from '@/common/lib/ckEditor'
const AppModules = require('annonces-app-modules')(process.env.APP_NAME, process.env.NODE_ENV)

Vue.config.productionTip = false
Vue.prototype.$commercantTrade = null

Vue.prototype.$tradeSwitch = function (userProps) {
  // loop sur toutes propriétés
  // de l'utilisateur
  for (const item in userProps) {
    switch (item) {

      // si l'une d'elles
      // est `module_boulangerie`
      // ou `module_fleuriste`
      case 'module_boulangerie':
      case 'module_fleuriste':

        // et que le module est actif ( module === 1 )
        if (userProps[item] === 1) {
          // sortie de la méthode
          return item.replace('module_', '')
        }

        break
    }
  }
  return 'trad'
}

router.beforeEach((to, from, next) => {
  // console.log(to)
  AppModules.Store.set('fullPath', to.fullPath)
  AppModules.getUser().verify(to, from, function (err, success) {
    if (err) {
      console.log(err)
    }

    if (!success) {
      router.replace('/')
    }
  })
  //
  next()
})

router.afterEach((to, from) => {})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js